<!-- 复制草稿到其他公众号 弹窗 -->
<template>
<a-modal
	  :title="`复制 草稿箱的图文 到其他公众号`"
	  :visible="visible"
	  :confirm-loading="confirmLoading"
	  cancelText="取消"
	  okText="确认" 
	  width="1000px" 
	  @ok="modalOk"
	  @cancel="modalCancel"
	  
	>
	<div style="height: 600px;overflow-y: scroll;">
	<a-input-search placeholder="搜索公众号" style="width: 260px;margin-bottom: 15px;" @search="onSearchGzh($event,'search_button')" />
	
	<div v-for="(item,index) in menuData" :key="index">
		<div class="left-label" @click="changeMenu(item,index)" :style="{'color': item.style_status?'#1d99ff':''}">
			<a-icon v-if="!item.select_status" class="nav-icon" type="caret-right" />
			<a-icon v-else-if="item.select_status" class="nav-icon" type="caret-down" />
			<div v-show="nav_select_control" @click.stop>
				<a-checkbox @change.stop="checkA($event,item)"
				:checked="item.check_status"
				:indeterminate="item.check_indeterminate"
				style="margin-right: 10px;"></a-checkbox>
			</div>
			
			<span style="user-select: none;">{{item.name}}</span>
		</div>
		
		<template v-if="item.select_status">
			<template v-for="ite_z in item.value">
				<div v-if="item.name != '未分组'" @click="changeMenuB(ite_z)" style="padding-left: 20px;" class="left-label">
					<a-icon v-if="!ite_z.status" class="nav-icon" type="caret-right" />
					<a-icon v-else-if="ite_z.status" class="nav-icon" type="caret-down" />
					<div v-show="nav_select_control" @click.stop>
						<a-checkbox @change="checkB($event,ite_z,item)" 
						:checked="ite_z.check_status" 
						:indeterminate="ite_z.check_indeterminate"
						style="margin-right: 10px;"></a-checkbox>
					</div>
					{{ite_z.name}}
				</div>
				
				<div style="display: flex;flex-wrap: wrap;padding-left: 60px;" v-if="ite_z.status">
					<div v-for="(item_z,index_z) in ite_z.value" class="left-children-cell" style="display: flex;">
						<div v-show="nav_select_control" @click.stop>
							<a-checkbox @change="checkC($event,item_z,item)" 
							v-model="item_z.check_status" style="margin-right: 10px;"></a-checkbox>
						</div>
						{{item_z.gzh_name}}
					</div>
				</div>
			</template>
			
		</template>
	</div>
	</div>
</a-modal>
</template>

<script>
import { getChannelGzh, wxCopyDrafts } from '@/request/api'
export default {
	name: 'copyDraftsModal_',
	props: [],
	data(){
		return {
			visible: false,
			confirmLoading: false,
			
			menuData: [],
			nav_select_control: true, // 左侧边栏的多选框是否显示控制
			gzhSelectData: [], // 选中的公众号
			
			drafts_id: null, // 草稿箱ID
		}
	},
	methods: {
		showModal(d_id){
			let that = this
			
			that.drafts_id = d_id
			
			that.onSearchGzh(null)
		},
		onSearchGzh(e,type){
			let that = this
			
			getChannelGzh({
				gzh_name: e,
			}).then(res=>{
				console.log("获取渠道、分组、公众号",res);
				that.$emit("false-laoding")
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					that.visible = true
					let data = res.data.data.list
					let m_data = []
					for (let key in data) {
						let obj = {
							name: key,
							select_status: false,
							style_status: false,
							check_status: false,
							check_indeterminate: false,
							value: [],
						}
						let z_arr = []
						for (let z_ey in data[key]) {
							let z_bj = {
								name: z_ey,
								status: false,
								check_status: false,
								check_indeterminate: false,
								value: [],
							}
							data[key][z_ey].forEach(re_z=>{
								re_z.click_status = false
								re_z.check_status = false
							})
							z_bj.value = data[key][z_ey]
							z_arr.push(z_bj)
						}
						
						obj.value = z_arr
						m_data.push(obj)
					}
					console.log("m_data",m_data);
					that.menuData = m_data
				}
				else {
					that.$message.error(`错误：${res.data.msg}`);
				}
			})
		},
			
		// 切换书城列表
		changeMenu(e,index){
			// console.log("切换书城列表",e);
			e.select_status = !e.select_status
		},
		// 切换分组
		changeMenuB(ite_z){
			// console.log("ite_z",ite_z);
			ite_z.status = !ite_z.status
		},
		// 勾选渠道
		checkA(e,item){
			console.log("勾选渠道",e.target.checked);
			console.log("勾选渠道item",item);
			item.check_status = e.target.checked
			if(e.target.checked){
				item.check_indeterminate = false
				item.value.forEach(res=>{
					res.check_status = true
					res.value.forEach(re_z=>{
						re_z.check_status = true
					})
				})
			}
			else {
				item.check_indeterminate = false
				item.value.forEach(res=>{
					res.check_status = false
					res.value.forEach(re_z=>{
						re_z.check_status = false
					})
				})
			}
			// 校验检查
			this.checkStatus(item)
		},
		// 勾选分组
		checkB(e,ite_z,item){
			console.log("ite_z",ite_z);
			ite_z.check_status = e.target.checked
			if(e.target.checked){
				ite_z.value.forEach(re_z=>{
					re_z.check_status = true
				})
			}
			else {
				ite_z.value.forEach(re_z=>{
					re_z.check_status = false
				})
			}
			// 校验检查
			this.checkStatus(item)
		},
		// 勾选公众号
		checkC(e,item_z,item){
			console.log("item_z",item_z);
			// item_z.check_status = !item_z.check_status
			// 校验检查
			this.checkStatus(item)
		},
		// 校验全部勾选
		checkStatus(){
			let gzh = []
			this.menuData.forEach(item=>{
				let f = 0
				let d = 0
			
				item.value.forEach(res=>{
					let i = 0
					let for_i = 0
					res.value.forEach(re_z=>{
						for_i++
						if(re_z.check_status){
							i++
							gzh.push(re_z) // 把已选的公众号筛选出来
						}
					})
					
					if(for_i == res.value.length){
						if(i == res.value.length){ // 全选
							res.check_status = true
							res.check_indeterminate = false
						}
						else if(i > 0 && i < res.value.length){ // 表示有选中的，但是没有全选
							res.check_status = false
							res.check_indeterminate = true
						}
						else if(i == 0){ // 表示一个都没有选中
							res.check_status = false
							res.check_indeterminate = false
						}
					}
					
					
					if(res.check_status){
						f++
					}
					if(res.check_indeterminate){
						d++
					}
				})
				
				if(f == item.value.length){ // 表示全选
					item.check_status = true
					item.check_indeterminate = false
				}
				else if(f > 0 && f < item.value.length){
					item.check_status = false
					item.check_indeterminate = true
				}
				else if(d > 0){
					item.check_status = false
					item.check_indeterminate = true
				}
				else if(d == 0){
					item.check_status = false
					item.check_indeterminate = false
				}
			})
			
			this.gzhSelectData = gzh
		},
		
		modalOk(){
			let that = this
			console.log("确认按钮");
			let i_data = []
			this.gzhSelectData.forEach(res=>{
				i_data.push(res.id)
			})
			that.confirmLoading = true
			wxCopyDrafts({
				ids: i_data, // 需要同步到指定公众号id数组
				draft_id: that.drafts_id, // 草稿箱id
			}).then(res=>{
				console.log("复制结果",res);
				that.confirmLoading = false
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					// that.$message.success(res.data.msg);
					that.modalCancel()
					// that.$emit("modal-ok",'')
					that.$confirm({
						title: res.data.msg,
						icon:"exclamation-circle",
						class:'jlzh',//类名
						okText: "查看进度",
						cancelText: "取消",
						content: h => <div >点击按钮前往-草稿箱新建记录</div>,
						onOk() {
						  console.log('OK');
						  
						  const { href } = that.$router.resolve({path: '/syncWxRecord', query: {  jump_type: '2' }})
						  window.open(href, '_blank');
						},
						onCancel() {
						  console.log('Cancel');
						},
						
					});
				}
				else {
					that.$message.error(`错误：${res.data.msg}`);
				}
			})
		},
		modalCancel(){
			this.visible = false
		},
	}
}
</script>

<style scoped>
.big-menu-box {
	position: sticky;
	top: 80px;
	/* border-right: 1px solid #e8e8e8; */
	padding: 13px 13px 0;
	background-color: #fff;
	width: 218px;
}
.left-menu-box {
	height: 100%;
	overflow-y: overlay;
	margin-right: -15px;
	padding-right: 15px;
}
.left-label {
	height: 40px;
	display: flex;
	align-items: center;
	/* justify-content: space-between; */
	cursor: pointer;
	padding: 0 10px 0 5px;
	margin-bottom: 3px;
	font-size: 13px;
}
.left-label:hover {
	/* color: #1d99ff; */
	background-color: #f2f3f5;
}
.left-children-cell {
	margin-bottom: 3px;
	font-size: 13px;
	padding: 5px;
	margin-right: 12px;
	/* user-select: none; */
}

.nav-icon {
	color: #666;
	font-size: 12px;
	margin-right: 7px;
}
</style>